import type { OpcaoGrupoDeLocaisDeTrabalho } from '../catalogo-grupo-de-locais-de-trabalho.tipos'

export type ListarOpcoesGrupoDeLocaisDeTrabalhoRepositorio = (
  sinal: AbortSignal,
) => Promise<readonly OpcaoGrupoDeLocaisDeTrabalho[]>

export const criarCasoDeUsoListarOpcoesGrupoDeLocaisDeTrabalho = (
  listarNoRepositorio: ListarOpcoesGrupoDeLocaisDeTrabalhoRepositorio,
): ListarOpcoesGrupoDeLocaisDeTrabalhoRepositorio => async (sinal) => (
  listarNoRepositorio(sinal)
)
